import React from 'react'

import { LntButton } from '@app/components/base'
import { Icon } from '@app/components/util'

import { ICON_NAME } from '@app/constants/icon'

import type { TriggerProps } from './types'

const DEFAULT_ICON_SIZE = '1.4em'

export const Trigger: React.FC<TriggerProps> = props => {
  const { children, isOpen, ...restProps } = props

  const icon = isOpen
    ? (
      <Icon
        size={ DEFAULT_ICON_SIZE }
        name={ ICON_NAME.arrowUp }
      />
      )
    : (
      <Icon
        size={ DEFAULT_ICON_SIZE }
        name={ ICON_NAME.arrowDown }
      />
      )

  return (
    <LntButton { ...restProps }>
      { children }
      { icon }
    </LntButton>
  )
}
